import React from 'react'
import { useState } from "react";
import "./footer.css"
import WhiteLogo from "../../assets/Akasha Logo.png"
import RightArrow from "../../assets/right-arrow.png"
import {  Modal } from 'antd';
import ModalCheck from "../../assets/modal-check.png"

const Footer = () => {
  const formspreeKey = process.env.REACT_APP_FORMSPREE_KEY;

  const [email, setEmail] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setEmail("");

    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setEmail("");

    setIsModalOpen(false);
  };

  const handleSubmit = async () => {
    if (!email) {
      alert("Please enter an email address!");
      return;
    }

    try {
      const response = await fetch(`https://formspree.io/f/${formspreeKey}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email })
      });

      if (response.ok) {
        // alert("Subscribed Successfully!");
        showModal();
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    }
  };


  return (
    <>
      <div className='footer-section'>
        <div className='footer-width'>
          <div className='copyrights'>2025 Akasha. All rights reserved.</div>
          <img src={WhiteLogo} alt="" className='footer-logo' />
          <div className='newsletter'>
            <div className='newsletter-head'>Subscribe to Our Newsletter</div>
            <div className='newsletter-desc'>for the latest Akasha updates.</div>
            <div className='newsletter-input'>
              <input placeholder='Enter email' className='footer-input' value={email}
                onChange={(e) => setEmail(e.target.value)}
                required />
              <img src={RightArrow} alt='' className='footer-arrow' onClick={handleSubmit} />
            </div>
          </div>
        </div>
      </div>

      <Modal title="" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={""}>
        <img src={ModalCheck} alt="" className='modal-img' />
        <div className='modal-head'>Email Confirmed!</div>
        <div className='modal-desc'>Your <span style={{ fontWeight: 600 }}>{email}</span> has been subscribed to our Newsletter.</div>
      </Modal>
    </>
  )
}

export default Footer
